// Vendor imports
const { connect } = require('react-redux')
// Container imports
const PromoBadge = require('./component-dumb')
const promoSelectors = require('./selectors')

function mapStateToProps() {
  const promoByIdSelector = promoSelectors.createPromoByIdSelector()
  return function (state, ownProps) {
    if (ownProps.id) {
      return promoByIdSelector(state, ownProps.id)
    }
    return (
      promoSelectors.browserPromoSelector(state) ||
      // Fall back to the most-popular browser
      promoByIdSelector(state, 'chrome')
    )
  }
}

const SmartComponent = connect(
  mapStateToProps
)(
  PromoBadge
)

module.exports = SmartComponent
